import {
    apiRequest,
    kgbList,
    kgbInactive,
    kgbActive
} from "../../../../../services/adapters/kepegawaian/kgbService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kgbList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kgbInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kgbActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository